/* Universal javascript */
import Alpine from 'alpinejs'
import htmxEvents from './utils/htmx-events.js'
import measurementConverter from './utils/measurement-converter.js'
import measurementUnitStore from './utils/measurement-unit-store.js'
import measurementUnitToggle from './utils/measurement-unit-toggle.js'
import productMatcher from './utils/product-matcher.js'
import refreshCsrfToken from './utils/refresh-csrf-token.js'
import * as swiperModule from './utils/swiper.js'
import * as plyrModule from './utils/plyr.js'

window.Alpine = Alpine;
Alpine.store('measurementUnit', measurementUnitStore())
Alpine.data('measurementConverter', measurementConverter)
Alpine.data('measurementUnitToggle', measurementUnitToggle)
Alpine.data('productMatcher', productMatcher)
Alpine.start()

document.addEventListener("DOMContentLoaded", () => {
    htmxEvents.init()
    refreshCsrfToken.init();

    setTimeout(() => {
        if (document.querySelector('.swiper')) {
            swiperModule.default.init()
        }

        if (document.querySelector('.js-player')) {
            plyrModule.default.init()
        }
    }, 100)
});
